import "@/App.css";
import MigrationTool from "@/pages/MigrationTool";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="dark">
      <MigrationTool />
      <Toaster position="top-right" theme="dark" richColors />
    </div>
  );
}

export default App;
